import { useContext, useEffect } from 'react'
import { ConfirmationWrapper } from 'src/modules/confirmation/containers'
import { LoadingWrapperContext } from 'src/modules/core/context'

import classes from './confirmation.module.scss'

export const Confirmation = () => {
  const { disableLoading } = useContext(LoadingWrapperContext)

  useEffect(() => {
    disableLoading()
  }, [disableLoading])

  return (
    <div className={classes.root}>
      <ConfirmationWrapper />
    </div>
  )
}
